import { css } from 'aphrodite';
import { getTextingOptOutMessage } from '../../../../models/accountFeatures';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { OutboundTextMessageBubble } from '../MessageBubble/OutboundTextMessageBubble';
import { brandPrimary } from '../../../styles/colors';
import { bs } from '../../../styles/styles';

export function TextCampaignFooter() {
	const userSession = useUserSession();
	return (
		<div className={css(bs.mt4)}>
			<OutboundTextMessageBubble backgroundColor={brandPrimary}>
				{getTextingOptOutMessage(userSession?.account?.features?.texting)}
			</OutboundTextMessageBubble>
			<div className={css(bs.textRight, bs.textXs, bs.textHeader, bs.italic, bs.mt1)}>*Required by CAN-SPAM</div>
		</div>
	);
}
